import axios from 'axios';
import {
    dietRequest,
    dietFail,
    templatesSuccess,
    templateCreatedSuccess,
    templateUpdatedSuccess,
    templateDeletedSuccess,
    allPatientDietsSuccess,
    patientDietsSuccess,
    singleDietSuccess,
    dietCreatedSuccess,
    dietUpdatedSuccess,
    dietDeletedSuccess
} from '../slices/dietSlice';

// 1. Get Master Diet Templates (Searchable)
export const getDietTemplates = (keyword = '') => async (dispatch) => {
    try {
        dispatch(dietRequest());
        const url = keyword ? `/api/v1/diet-templates?keyword=${encodeURIComponent(keyword)}` : '/api/v1/diet-templates';
        const { data } = await axios.get(url);
        dispatch(templatesSuccess(data.templates));
    } catch (err) {
        dispatch(dietFail(err.response?.data?.message || 'Failed to fetch diet templates'));
    }
};

// 2. Create Master Diet Template
export const createDietTemplate = (templateData) => async (dispatch) => {
    try {
        dispatch(dietRequest());
        const { data } = await axios.post('/api/v1/diet-template/new', templateData);
        dispatch(templateCreatedSuccess(data.template));
    } catch (err) {
        dispatch(dietFail(err.response?.data?.message || 'Failed to create diet template'));
    }
};

// 3. Delete Master Diet Template
export const deleteDietTemplate = (id) => async (dispatch) => {
    try {
        dispatch(dietRequest());
        await axios.delete(`/api/v1/diet-template/${id}`);
        dispatch(templateDeletedSuccess(id));
        return { success: true };
    } catch (err) {
        const errorMsg = err.response?.data?.message || 'Failed to delete diet template';
        dispatch(dietFail(errorMsg));
        return { success: false, error: errorMsg };
    }
};

// 3b. Update Master Diet Template
export const updateDietTemplate = (id, templateData) => async (dispatch) => {
    try {
        dispatch(dietRequest());
        const { data } = await axios.put(`/api/v1/diet-template/${id}`, templateData);
        dispatch(templateUpdatedSuccess(data.template));
        return { success: true, template: data.template };
    } catch (err) {
        const errorMsg = err.response?.data?.message || 'Failed to update diet template';
        dispatch(dietFail(errorMsg));
        return { success: false, error: errorMsg };
    }
};

// 4. Get Patient Diets
export const getPatientDiets = (patientId) => async (dispatch) => {
    try {
        dispatch(dietRequest());
        const { data } = await axios.get(`/api/v1/patient/${patientId}/diets`);
        dispatch(patientDietsSuccess(data.diets));
    } catch (err) {
        dispatch(dietFail(err.response?.data?.message || 'Failed to fetch patient diets'));
    }
};

// 5. Create Patient Diet (Digital or File)
export const createPatientDiet = (patientId, dietData) => async (dispatch) => {
    try {
        dispatch(dietRequest());

        let res;
        if (dietData instanceof FormData) {
            res = await axios.post(`/api/v1/patient/${patientId}/diet`, dietData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        } else {
            res = await axios.post(`/api/v1/patient/${patientId}/diet`, dietData);
        }

        dispatch(dietCreatedSuccess(res.data.diet));
        return { success: true, diet: res.data.diet };
    } catch (err) {
        const errorMsg = err.response?.data?.message || 'Failed to save diet plan';
        dispatch(dietFail(errorMsg));
        return { success: false, error: errorMsg };
    }
};

// 6. Get Single Diet
export const getSingleDiet = (id) => async (dispatch) => {
    try {
        dispatch(dietRequest());
        const { data } = await axios.get(`/api/v1/diet/${id}`);
        dispatch(singleDietSuccess(data.diet));
        return data.diet;
    } catch (err) {
        dispatch(dietFail(err.response?.data?.message || 'Failed to fetch diet details'));
    }
};

// 7. Update Patient Diet
export const updatePatientDiet = (id, dietData) => async (dispatch) => {
    try {
        dispatch(dietRequest());
        const { data } = await axios.put(`/api/v1/diet/${id}`, dietData);
        dispatch(dietUpdatedSuccess(data.diet));
        return { success: true, diet: data.diet };
    } catch (err) {
        const errorMsg = err.response?.data?.message || 'Failed to update diet plan';
        dispatch(dietFail(errorMsg));
        return { success: false, error: errorMsg };
    }
};

// 8. Delete Patient Diet
export const deletePatientDiet = (id) => async (dispatch) => {
    try {
        dispatch(dietRequest());
        await axios.delete(`/api/v1/diet/${id}`);
        dispatch(dietDeletedSuccess(id));
        return { success: true };
    } catch (err) {
        const errorMsg = err.response?.data?.message || 'Failed to delete diet plan';
        dispatch(dietFail(errorMsg));
        return { success: false, error: errorMsg };
    }
};

// 9. Get / Search All Prescribed Diets (Cross-patient)
export const getAllPatientDiets = (keyword = '') => async (dispatch) => {
    try {
        dispatch(dietRequest());
        const url = keyword ? `/api/v1/all-patient-diets?keyword=${encodeURIComponent(keyword)}` : '/api/v1/all-patient-diets';
        const { data } = await axios.get(url);
        dispatch(allPatientDietsSuccess(data.diets));
        return data.diets;
    } catch (err) {
        dispatch(dietFail(err.response?.data?.message || 'Failed to fetch prescribed diets'));
    }
};


